import i18n from './attribute-category.properties';

const AttributeCategoryInternal = {
  MEASURE: 'MEASURE',
  DIMENSION: 'DIMENSION',
  HIERARCHY: 'HIERARCHY',
} as const;

/** @deprecated Use the type instead */
export const AttributeCategory = {
  ...AttributeCategoryInternal,
  values: [...Object.values(AttributeCategoryInternal)],
  i18n: (key: AttributeCategory, options?: { count?: number }) => i18n(key, options),
} as const;

/** @see net.disy.cadenza.repository.api.objecttype.AttributeCategory */
export type AttributeCategory = keyof typeof AttributeCategoryInternal;
